function init() {
	var $menu = $('#menu');
	var $menuMain = $('#menu .menu-main');
	var $tabNav = $('#menu .tab-nav');
	var $header = $('#header');
	var $rightmenuBtn = $('#show-rightmenu');
	var headerHeight = $header.height();

	window.addEventListener('scroll', function() {
		if (_getScrollTop() > headerHeight ) {
			$menu.addClass('menu--fixed');
		} else {
			if( windowWidth >= SCREEN.SM ) {
				$menu.removeClass('menu--fixed');
			}
		}
	});

	if ( windowWidth <= SCREEN.SM ) {
		$rightmenuBtn.addClass('show');
	}

	$rightmenuBtn.on('click',function () {
		$menu.toggleClass('show');
		$body.toggleClass('hide-overflow--nopad');
	});

	$('.menu-overlayer').on('click',function () {
		$menu.removeClass('show');
		$body.removeClass('hide-overflow--nopad');
	});

	$document.on('click.show-menu', function(event) {
		if ($menu.hasClass('show')) {
			if (!$(event.target).closest('.tab--menu,#show-rightmenu').length) {
				$menu.removeClass('show');
				$body.removeClass('hide-overflow--nopad');
			}
		}
	});

	/**
	 * set height because 'simple-scrollbar' needs it
	 */
	function setMenuMainHeight() {
		$menuMain.css({
			height: (windowHeight - $header.outerHeight() - $tabNav.outerHeight()) + 'px'
		});

		if( windowWidth <= SCREEN.SM ){
			$menu.addClass('menu--fixed');
			$rightmenuBtn.addClass('show');
		}else{
			$rightmenuBtn.removeClass('show');
			if ( $menu.hasClass('menu--fixed') ){
				$menu.removeClass('menu--fixed show');
				$body.removeClass('hide-overflow--nopad');
			}
		}
	}

	setMenuMainHeight();
	window.addEventListener('resize', setMenuMainHeight);
}


$(function() {
	init();
});